export default __webpack_public_path__ + "static/media/evan.658f0658.png";